import Api from './Api';

export default {
    login(username, password) {
        return Api.post('/users/login', {
            username: username,
            password: password
        });
    },
    requestPasswordReset(email_address) {
        return Api.post('/users/requestPasswordReset', {
            email_address: email_address
        });
    },
    resetPassword(data) {
        return Api.post('/users/resetPassword', data);
    }
}
